import { formatDateISO, startOfTodayUTC } from "@/lib/dateConstraints";

export const MSME_DATE_FIELD = "msme_registration_date";
export const MSME_DATE_LABEL = "MSME Date of Registration";

export function todayISODate(): string {
  return formatDateISO(startOfTodayUTC());
}
